<template>
  <div class="col-12 mb-2 new-annotation-container">
    <div v-if="!active" :content="$t('more.new_annotation')" v-tippy class="fill-parent new-annotation-inactive p-2" @click="activeAndFocus">
      <span class="new-annotation-icon sli-plus"></span>
    </div>
    <div v-if="active" class="new-annotation-active p-2 fill-parent d-flex">
      <form @submit.prevent data-vv-scope="form-new-annotation" style="width: 100%;">
        <div class="new-annotation-textarea-container">
          <label for="annotation_text">{{ $t('more.annotation') }}</label>
          <textarea tabindex="0" rows="4" id="new-annotation-text-area" name="annotation_text" v-validate="{ required: true, min: 1, max: 255 }" v-model="annotation.text" class="form-control" :class="{ 'is-invalid': newAnnotationSubmitted && errors.has('form-new-annotation.annotation_text') }" :data-vv-as="$t('more.annotation_text')" @keydown="inputHandler"/>
          <div v-if="newAnnotationSubmitted && errors.has('form-new-annotation.annotation_text')" class="invalid-feedback">{{ errors.first('form-new-annotation.annotation_text') }}</div>
          <span class="new-annotation-button nab-check sli-check" @click="submit"></span>
          <span class="new-annotation-button nab-close sli-close" @click="cancel"></span>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    active: false,
    newAnnotationSubmitted: false,
    annotation: {}
  }),
  methods: {
    resetModel () {
      this.active = false
      this.newAnnotationSubmitted = false
      this.annotation = {}
    },
    activeAndFocus () {
      this.resetModel()
      this.active = true
      setTimeout(() => {
        $('#new-annotation-text-area').focus()
      }, 100)
    },
    inputHandler (e) {
      if (e.keyCode === 13 && e.shiftKey) {
        e.preventDefault()
        this.submit()
      } else if (e.keyCode === 27) {
        e.preventDefault()
        this.cancel()
      }
    },
    cancel () {
      this.resetModel()
      this.$emit('canceled')
    },
    submit () {
      this.newAnnotationSubmitted = true
      if (this.annotation.text.length === 0 || this.annotation.text.length > 255) {
        console.error('annotation text is empty or too long.')
        return
      }
      this.$emit('submitted', this.annotation.text)
      this.resetModel()
      /* this.$validator.validateAll('form-new-annotation').then(valid => {
        if (valid) {
          this.$emit('submitted', this.annotation.text)
          this.resetModel()
        }
      }) */
    },
    setTextValue (text) {
      this.resetModel()
      this.annotation.text = text
      this.active = true
      setTimeout(() => {
        $('#new-annotation-text-area').focus()
      }, 100)
    }
  }
}
</script>

<style>
.fill-parent {
  width: 100%;
  height: 100%;
}
.new-annotation-container {
  background-color: var(--annotation-new-bg-color);
  transition: background-color .15s ease-in-out;
  margin-top: 2em;
  border-radius: 3px;
}
.new-annotation-container:hover {
  background-color: var(--annotation-new-hover-bg-color);
}
.new-annotation-inactive {
  text-align: center;
}
.new-annotation-active {
  text-align: start;
  align-items: flex-end;
}
.new-annotation-icon {
  font-size: 2em;
}
.new-annotation-textarea-container {
  position: relative;
  flex-grow: 1;
}
#new-annotation-text-area {
  padding-left: calc(1.5em + 0.75rem);
}
#new-annotation-text-area.is-invalid {
  padding-right: 0.76923rem !important;
}
.new-annotation-button {
  transition: opacity .15s ease-in-out;
  position: absolute;
  font-size: 1.5em;
  left: 0.5em;
  opacity: 0.8;
}
.new-annotation-button:hover {
  opacity: 1.0;
}
.nab-check {
  top: 3.0em;
  color: var(--green-flag-color);
}
.nab-close {
  top: 4.2em;
  color: var(--red-flag-color);
}
</style>



// WEBPACK FOOTER //
// src/components/NewAnnotation.vue